/** `http` reject 形态为 axios 的 response，业务错误在 `data.message` */
export function getHttpErrorMessage(err: unknown, fallback = '操作失败') {
  const res = err as { data?: { message?: string } }
  const msg = res?.data?.message
  return typeof msg === 'string' && msg.trim() ? msg : fallback
}
